export default __webpack_public_path__ + "static/media/100002.d12ad6df.jpg";